const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoney(value: number | string | null | undefined, fallback = '$0.00') {
  if (value === null || value === undefined || value === '') return fallback;

  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return isNaN(numValue) ? fallback : moneyFormatter.format(numValue);
}
